
import Vue from "vue";

export default Vue.extend({
    name: "AppError",
    data: () => ({
        showSelf: false,
    }),
    props: {
        snackbarMessage: {
            type: String,
            required: true,
            default: "",
        },
        showSnackbar: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    watch: {
        showSnackbar() {
            this.showSelf = true;
        },
    },
});
